import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gbc-modal-content',
    templateUrl: './modal-content.component.html',
    styleUrls: ['./modal-content.component.scss'],
    standalone: true
})
export class ModalContentComponent {
}
